import ACTION_TYPE from 'components/../redux/actions/actionTypes';
import ApiHelper from 'utils/apiHelper';
import { API_URL } from 'utils/constants';
import { toast } from 'react-toastify';

export const getOrganizationData = () => (dispatch) => {
    dispatch({
        type: ACTION_TYPE.LOADING_MANAGEMENT_DTL,
        fieldName: 'organization',
        data: true
    });
    ApiHelper.get(API_URL.MANAGEMENT_ORGANIZATION_DATA)
        .then((res) => {
            dispatch({
                type: ACTION_TYPE.UPDATE_MANAGEMENT_DTL,
                fieldName: 'organization',
                data: {
                    data: res.data
                }
            });
        })
        .catch((err) => {
            if (err.response.status !== 401) {
                toast.error('Failed to get the organizations data');
            }
            dispatch({
                type: ACTION_TYPE.LOADING_MANAGEMENT_DTL,
                fieldName: 'organization',
                data: false
            });
        });
};

export const selectManagingOrg = (data) => async (dispatch) => {
    dispatch({
        type: ACTION_TYPE.LOADING_MANAGEMENT_DTL,
        fieldName: 'organization',
        data: true
    });
    ApiHelper.post(API_URL.MANAGING_ORGANIZATION, {
        manage_organization_id: data.orgid
    })
        .then(() => {
            dispatch({
                type: ACTION_TYPE.UPDATE_MANAGEMENT_DTL,
                fieldName: 'organization',
                data: {
                    selected: data
                }
            });
            console.log('here1');
            return Promise.resolve();
        })
        .catch((err) => {
            if (err.response.data.message !== '') {
                toast.error(`Failed! ${err.response.data.message}`);
            } else {
                toast.error('Failed to manage the organization');
            }
            dispatch({
                type: ACTION_TYPE.LOADING_MANAGEMENT_DTL,
                fieldName: 'organization',
                data: false
            });
        });
};

export const viewsList = (views) => ({
    type: ACTION_TYPE.SET_VIEWS_LIST,
    fieldName: 'viewsList',
    data: views
});

export const setGroups = (groups) => ({
    type: ACTION_TYPE.SET_GROUPS,
    fieldName: 'groups',
    data: groups
});

export const setDeviceTypes = (deviceTypes) => ({
    type: ACTION_TYPE.SET_DEVICE_TYPES,
    fieldName: 'deviceTypes',
    data: deviceTypes
});

export const setPolicies = (policies) => ({
    type: ACTION_TYPE.SET_POLICIES,
    fieldName: 'policies',
    data: policies
});

export const setLicenses = (licenses) => ({
    type: ACTION_TYPE.SET_LICENSES,
    fieldName: 'licenses',
    data: licenses
});

export const setLabels = (labels) => ({
    type: ACTION_TYPE.SET_LABELS,
    fieldName: 'labels',
    data: labels
});
